import IApiCommand from '@/api/IApiCommand';

import RetryManager from '@/api/RetryManager';
import ICommandPollingNotificationHandler from './ICommandPollingNotificationHandler';

class CommandPollingManager<T> {
  private readonly command: IApiCommand<T>;
  private readonly delayTime: number;
  private readonly retryManager: RetryManager = new RetryManager();
  private readonly notificationHandler: ICommandPollingNotificationHandler<T>;
  private pollingManagerWorker: PollingManagerWorker<T> | undefined;
  constructor(command: IApiCommand<T>, delayTime: number, notificationHandler: ICommandPollingNotificationHandler<T>) {
    this.command = command;
    this.delayTime = delayTime;
    this.notificationHandler = notificationHandler;
  }

  start(): void {
    if (this.pollingManagerWorker) {
      this.pollingManagerWorker.stop();
      this.pollingManagerWorker = undefined;
    }

    this.pollingManagerWorker = new PollingManagerWorker(this.command, this.delayTime, this.notificationHandler);
    this.pollingManagerWorker.runCommand(0);
  }

  stop(): void {
    if (this.pollingManagerWorker) {
      this.pollingManagerWorker.stop();
      this.pollingManagerWorker = undefined;
    }
  }
}

class PollingManagerWorker<T> {
  private readonly command: IApiCommand<T>;
  private readonly delayTime: number;
  private notificationHandler: ICommandPollingNotificationHandler<T> | undefined;
  private running = true;
  private readonly retryManager: RetryManager = new RetryManager();

  constructor(command: IApiCommand<T>, delayTime: number, notificationHandler: ICommandPollingNotificationHandler<T>) {
    this.command = command;
    this.delayTime = delayTime;
    this.notificationHandler = notificationHandler;
  }

  stop(): void {
    this.notificationHandler = undefined;
    this.running = false;
  }

  runCommand(delay: number): void {
    if (!this.running) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    setTimeout(function () {
      that.retryManager
        .runCommand(that.command)
        .then((data) => {
          if (that.running && data && that.notificationHandler) {
            that.notificationHandler.commandPollingNotification(data);
            that.runCommand(that.delayTime);
          }
        })
        .catch((error) => {
          if (that.notificationHandler) {
            that.notificationHandler.commandPollingNotificationError(error);
          }
        });
    }, delay);
  }
}

export default CommandPollingManager;
